import { BettingMode } from '@/features/betslip/betting-mode';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { accountService } from '@/services/account.service';
import { useAccountInfo } from './query/account';
import { BetslipStyle } from './query';

export const useBettingPrefer = ({
	initialMode,
	initialStyle,
	syncOnCondition,
}: {
	initialMode: number;
	initialStyle: number;
	syncOnCondition: boolean;
}) => {
	const [selectedBettingMode, setSelectedBettingMode] = useState<number>(initialMode);
	const [selectedBetslipStyle, setSelectedBetslipStyle] = useState<number>(initialStyle);
	const { user } = useAccountInfo();
	const queryClient = useQueryClient();

	useEffect(() => {
		if (syncOnCondition) {
			setSelectedBettingMode(user?.UserSetting?.BettingMode ?? BettingMode.Independent);
			setSelectedBetslipStyle(user?.UserSetting?.BetslipStyle ?? BetslipStyle.basic);
		}
	}, [syncOnCondition, user?.UserSetting?.BettingMode, user?.UserSetting?.BetslipStyle]);

	const selectBettingMode = (bettingMode: number) => {
		setSelectedBettingMode(bettingMode);
	};

	const selectBetslipStyle = (betslipStyle: number) => {
		setSelectedBetslipStyle(betslipStyle);
	};

	const saveBettingPrefer = () => {
		if (user?.UserSetting?.BettingMode !== selectedBettingMode || user?.UserSetting?.BetslipStyle !== selectedBetslipStyle) {
			const safeUserSetting = accountService.getSafeUserSetting(user?.UserSetting);
			const newUserSetting = {
				...safeUserSetting,
				BettingMode: selectedBettingMode,
				BetslipStyle: selectedBetslipStyle
			};
			user && accountService.setUserSetting(queryClient, newUserSetting);
		}
	};
	

	return {
		selectedBettingMode,
		selectBettingMode,
		selectedBetslipStyle,
		selectBetslipStyle,
		saveBettingPrefer
	};
};